import React from 'react';
import {
  ATMContainer,
  ATMHeader,
  IORGDataTableColumn,
  ORGDataTable,
} from 'shared-it-appmod-ui';
import Lang from 'src/libraries/language';
import { ISetting } from 'src/models/setting.model';
import style from './configuration-settings-list.module.scss';
import ConfigurstionSettingsEdit from '../configuration-settings-edit/configuration-settings-edit.component';

type IProp = {
  data: ISetting[];
  loading: boolean;
};

const ConfigurationSettingsListView: React.FC<IProp> = ({ data, loading }) => {
  const customColumns: IORGDataTableColumn<ISetting>[] = [
    {
      title: Lang.LBL_KEY,
      index: 'key',
      width: '15%',
    },
    {
      title: Lang.LBL_VALUE,
      index: 'value',
      width: '35%',
    },
    {
      title: Lang.LBL_DESCRIPTION,
      index: 'description',
      width: '35%',
      render: (value) => value,
    },
    {
      title: Lang.LBL_ACTIONS,
      index: 'actions',
      width: '15%',
      render: (_, value) => (
        <>
          <ConfigurstionSettingsEdit data={value} />
        </>
      ),
    },
  ];

  // for UT Coverage
  if (process.env.REACT_APP_SWITCH_TO_UNIT_TEST_MODE === 'true') {
    if (customColumns[2].render) {
      customColumns[2].render(true, {} as ISetting, 1, {} as any);
    }
    if (customColumns[3].render) {
      customColumns[3].render(true, {} as ISetting, 1, {} as any);
    }
  }

  return (
    <ATMContainer className={style.container}>
      <div className={style.header}>
        <ATMHeader as="h1" content={Lang.TTL_ADMIN_CONFIGURATION_SETTINGS} />
      </div>
      <ORGDataTable
        celled={false}
        columns={customColumns}
        data={data}
        loading={loading}
      />
    </ATMContainer>
  );
};

export default ConfigurationSettingsListView;
